/*
 * Velour — Hızlı Bakış (quick view).
 * Ürün kartındaki [data-vl-quick-view] tetikleyicisine delegated click ile bağlanır,
 * /products/{handle}.js JSON'unu çekip modali doldurur: galeri (ana görsel + thumbnail
 * şeridi) + başlık + fiyat + ücretsiz kargo barı + variant seçenekleri (görsel butonlar)
 * + adet stepper + Sepete Ekle + Favorilere Ekle (localStorage) + güven ikonları +
 * "Diğer Renkleri" (section rendering ile lazy fetch). Sepete Ekle butonu kart ile AYNI
 * akışa bağlanır: form[data-vl-add-form] + button.vl-card__add-btn → vl-product-card.js'in
 * global delegated submit listener'ı cart-drawer'ı açar. Global scope kirletmez.
 */
(function () {
  'use strict';

  var modal = document.querySelector('[data-vl-qv]');
  if (!modal) return;

  var dialog = modal.querySelector('[data-vl-qv-dialog]');
  var loadingEl = modal.querySelector('[data-vl-qv-loading]');
  var contentEl = modal.querySelector('[data-vl-qv-content]');
  var lastFocused = null;

  // localStorage favori anahtarı (wishlist app yoksa basit favori).
  var FAV_KEY = 'vl:favorites';

  // "Diğer Renkleri" section endpoint id (sections/vl-linked-colors.liquid).
  var LINKED_SECTION_ID = 'vl-linked-colors';

  // Aynı ürün ikinci kez açıldığında yeniden fetch etmemek için basit cache.
  var productCache = Object.create(null);
  // Diğer renkler HTML cache (product id → html).
  var linkedCache = Object.create(null);

  // Ücretsiz kargo barı ayarları (server-side data attribute'larından).
  var freeShip = (function () {
    if (modal.getAttribute('data-vl-fs-enabled') !== 'true') return null;
    var threshold = parseInt(modal.getAttribute('data-vl-fs-threshold'), 10) || 0;
    if (threshold <= 0) return null;
    return {
      threshold: threshold,
      message: modal.getAttribute('data-vl-fs-message') || '',
    };
  })();

  // Sepet fiyatı önizlemesi ayarları (server-side data attribute'larından).
  var cp = (function () {
    if (modal.getAttribute('data-vl-cp-enabled') !== 'true') return null;
    function num(attr) {
      return parseInt(modal.getAttribute(attr), 10) || 0;
    }
    return {
      global: num('data-vl-cp-global'),
      tags: [
        { tag: modal.getAttribute('data-vl-cp-tag1') || '', pct: num('data-vl-cp-pct1') },
        { tag: modal.getAttribute('data-vl-cp-tag2') || '', pct: num('data-vl-cp-pct2') },
        { tag: modal.getAttribute('data-vl-cp-tag3') || '', pct: num('data-vl-cp-pct3') },
      ],
      label: modal.getAttribute('data-vl-cp-label') || 'Sepette fırsat fiyatı',
      color: modal.getAttribute('data-vl-cp-color') || '#B59778',
    };
  })();

  // Beden/uzunluk gibi option'lar buton grubu olarak render edilir (hepsi zaten buton;
  // bu liste sadece görsel vurgu için "boyut" tipini işaretler).
  var SIZE_OPTION_RE = /beden|size|numara|uzunluk|length/i;

  function cartPreviewCents(product, variant) {
    if (!cp || !variant || !variant.available) return 0;
    var percent = 0;
    if (cp.global > 0) {
      percent = cp.global;
    } else {
      var tags = (product.tags || []).map(function (t) {
        return String(t).toLowerCase();
      });
      for (var i = 0; i < cp.tags.length; i++) {
        var entry = cp.tags[i];
        if (entry.tag && tags.indexOf(entry.tag.toLowerCase()) !== -1) {
          percent = entry.pct;
          break;
        }
      }
    }
    if (percent <= 0) return 0;
    return Math.round((variant.price * (100 - percent)) / 100);
  }

  function moneyFormat(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var fmt = (window.theme && window.theme.moneyFormat) || '{{amount}}';
      try {
        return window.Shopify.formatMoney(cents, fmt);
      } catch (e) {
        /* fallthrough */
      }
    }
    var value = (cents / 100).toLocaleString('tr-TR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return value + ' TL';
  }

  function openModal() {
    lastFocused = document.activeElement;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('vl-qv-open');
    if (typeof trapFocus === 'function' && dialog) {
      trapFocus(dialog);
    } else if (dialog) {
      dialog.focus();
    }
    document.addEventListener('keydown', onKeydown);
  }

  function closeModal() {
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('vl-qv-open');
    document.removeEventListener('keydown', onKeydown);
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(lastFocused);
    } else if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  }

  function onKeydown(event) {
    if (event.key === 'Escape') closeModal();
  }

  function showLoading() {
    if (loadingEl) loadingEl.hidden = false;
    if (contentEl) {
      contentEl.hidden = true;
      contentEl.innerHTML = '';
    }
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // ---------------- Gallery ----------------
  function galleryImages(product) {
    // /products/{handle}.js: product.images = tam boy URL dizisi.
    var imgs = (product.images && product.images.length ? product.images : []).slice();
    if (!imgs.length && product.featured_image) imgs = [product.featured_image];
    return imgs;
  }

  function sizedImage(url, w) {
    if (!url) return url;
    // Shopify CDN: width parametresi ekle (varsa mevcut width'i değiştir).
    var clean = url.replace(/([?&])width=\d+/i, '$1').replace(/[?&]$/, '');
    return clean + (clean.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function buildGallery(product) {
    var imgs = galleryImages(product);
    var mainSrc = imgs[0] || '';
    var mainHtml =
      '<div class="vl-qv__gallery-main">' +
        (mainSrc
          ? '<img data-vl-qv-main src="' + escapeHtml(sizedImage(mainSrc, 900)) + '" alt="' + escapeHtml(product.title) + '" width="600" height="800" loading="eager">'
          : '') +
      '</div>';

    var thumbsHtml = '';
    if (imgs.length > 1) {
      thumbsHtml = '<div class="vl-qv__thumbs" data-vl-qv-thumbs role="list">';
      imgs.slice(0, 8).forEach(function (src, i) {
        thumbsHtml +=
          '<button type="button" class="vl-qv__thumb' + (i === 0 ? ' is-active' : '') + '"' +
            ' data-vl-qv-thumb data-full="' + escapeHtml(sizedImage(src, 900)) + '"' +
            ' aria-label="Görsel ' + (i + 1) + '" role="listitem">' +
            '<img src="' + escapeHtml(sizedImage(src, 200)) + '" alt="' + escapeHtml(product.title) + ' - ' + (i + 1) + '" width="80" height="107" loading="lazy">' +
          '</button>';
      });
      thumbsHtml += '</div>';
    }

    return '<div class="vl-qv__media">' + mainHtml + thumbsHtml + '</div>';
  }

  function wireGallery() {
    var main = contentEl.querySelector('[data-vl-qv-main]');
    contentEl.querySelectorAll('[data-vl-qv-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (main && full) main.src = full;
        contentEl.querySelectorAll('[data-vl-qv-thumb]').forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      });
    });
  }

  // ---------------- Options (visual button groups) ----------------
  function buildOptions(product) {
    if (product.variants.length <= 1 || !product.options || product.has_only_default_variant) {
      return '';
    }
    var html = '<div class="vl-qv__options">';
    product.options.forEach(function (opt, optIndex) {
      var name = typeof opt === 'string' ? opt : opt.name;
      var isSize = SIZE_OPTION_RE.test(name);
      var seen = {};
      var optionValues = [];
      product.variants.forEach(function (v) {
        var val = v['option' + (optIndex + 1)];
        if (val != null && !seen[val]) {
          seen[val] = true;
          optionValues.push(val);
        }
      });
      html +=
        '<div class="vl-qv__opt-group" data-vl-qv-opt-group data-option-index="' + optIndex + '">' +
          '<div class="vl-qv__opt-head">' +
            '<span class="vl-qv__opt-name">' + escapeHtml(name) + '</span>' +
            '<span class="vl-qv__opt-current" data-vl-qv-opt-current="' + optIndex + '"></span>' +
          '</div>' +
          '<div class="vl-qv__opt-values' + (isSize ? ' vl-qv__opt-values--size' : '') + '" role="group" aria-label="' + escapeHtml(name) + '">';
      optionValues.forEach(function (val, i) {
        html +=
          '<button type="button" class="vl-qv__opt-btn' + (i === 0 ? ' is-selected' : '') + '"' +
            ' data-vl-qv-opt-btn data-option-index="' + optIndex + '" data-option-value="' + escapeHtml(val) + '">' +
            escapeHtml(val) +
          '</button>';
      });
      html += '</div></div>';
    });
    html += '</div>';
    return html;
  }

  function resolveVariant(product) {
    var buttons = contentEl.querySelectorAll('.vl-qv__opt-btn.is-selected');
    if (!buttons.length) {
      return product.variants[0];
    }
    var chosen = [];
    buttons.forEach(function (btn) {
      chosen[parseInt(btn.getAttribute('data-option-index'), 10)] = btn.getAttribute('data-option-value');
    });
    return (
      product.variants.filter(function (v) {
        for (var i = 0; i < chosen.length; i++) {
          if (chosen[i] != null && v['option' + (i + 1)] !== chosen[i]) return false;
        }
        return true;
      })[0] || product.variants[0]
    );
  }

  function updateVariantState(product) {
    var variant = resolveVariant(product);
    var idInput = contentEl.querySelector('[data-vl-qv-id]');
    var priceEl = contentEl.querySelector('[data-vl-qv-price]');
    var btn = contentEl.querySelector('.vl-card__add-btn');
    var previewEl = contentEl.querySelector('[data-vl-qv-preview]');
    var stockEl = contentEl.querySelector('[data-vl-qv-stock]');
    if (idInput) idInput.value = variant ? variant.id : '';

    // Seçili option değerlerini başlık yanına yaz + ilgili variant görselini göster.
    contentEl.querySelectorAll('[data-vl-qv-opt-current]').forEach(function (el) {
      var idx = parseInt(el.getAttribute('data-vl-qv-opt-current'), 10);
      el.textContent = variant ? variant['option' + (idx + 1)] || '' : '';
    });

    if (priceEl && variant) {
      var html = moneyFormat(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html =
          '<span class="vl-qv__price-sale">' + moneyFormat(variant.price) + '</span>' +
          '<s class="vl-qv__price-compare">' + moneyFormat(variant.compare_at_price) + '</s>';
      }
      priceEl.innerHTML = html;
    }
    if (previewEl) {
      var previewCents = cartPreviewCents(product, variant);
      if (previewCents > 0) {
        previewEl.innerHTML =
          '<span class="vl-cart-preview__label">' + escapeHtml(cp.label) + '</span>' +
          '<span class="vl-cart-preview__amount">' + moneyFormat(previewCents) + '</span>';
        previewEl.hidden = false;
      } else {
        previewEl.innerHTML = '';
        previewEl.hidden = true;
      }
    }
    if (stockEl) {
      if (variant && variant.available && typeof variant.inventory_quantity === 'number' &&
          variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= 10) {
        stockEl.textContent = 'Son ' + variant.inventory_quantity + ' adet';
        stockEl.hidden = false;
      } else {
        stockEl.textContent = '';
        stockEl.hidden = true;
      }
    }
    if (btn) {
      var available = variant && variant.available;
      btn.disabled = !available;
      var label = btn.querySelector('[data-vl-add-label]');
      if (label) label.textContent = available ? 'Sepete ekle' : 'Tükendi';
    }

    // Variant'ın öne çıkan görseline geç (renk seçimi görseli değiştirsin).
    if (variant && variant.featured_image && variant.featured_image.src) {
      var main = contentEl.querySelector('[data-vl-qv-main]');
      if (main) {
        main.src = sizedImage(variant.featured_image.src, 900);
        contentEl.querySelectorAll('[data-vl-qv-thumb]').forEach(function (t) {
          t.classList.remove('is-active');
        });
      }
    }
  }

  // ---------------- Quantity stepper ----------------
  function wireStepper() {
    var input = contentEl.querySelector('[data-vl-qv-qty]');
    var minus = contentEl.querySelector('[data-vl-qv-qty-minus]');
    var plus = contentEl.querySelector('[data-vl-qv-qty-plus]');
    function normalize() {
      var n = parseInt(input && input.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (input) input.value = n;
      return n;
    }
    if (minus) minus.addEventListener('click', function () { if (input) { input.value = Math.max(1, normalize() - 1); } });
    if (plus) plus.addEventListener('click', function () { if (input) { input.value = normalize() + 1; } });
    if (input) input.addEventListener('change', normalize);
  }

  // ---------------- Favorites (localStorage) ----------------
  function readFavs() {
    try { return JSON.parse(localStorage.getItem(FAV_KEY)) || []; }
    catch (e) { return []; }
  }
  function writeFavs(list) {
    try { localStorage.setItem(FAV_KEY, JSON.stringify(list)); } catch (e) { /* private mode */ }
  }
  function syncFav(btn) {
    var handle = btn.getAttribute('data-fav-handle');
    var active = readFavs().indexOf(handle) !== -1;
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    var label = btn.querySelector('.vl-qv__fav-label');
    if (label) label.textContent = active ? 'Favorilerde' : 'Favorilere ekle';
  }
  function wireFav() {
    var btn = contentEl.querySelector('[data-vl-qv-fav]');
    if (!btn) return;
    syncFav(btn);
    btn.addEventListener('click', function () {
      var handle = btn.getAttribute('data-fav-handle');
      var list = readFavs();
      var idx = list.indexOf(handle);
      if (idx === -1) list.push(handle); else list.splice(idx, 1);
      writeFavs(list);
      syncFav(btn);
      document.dispatchEvent(new CustomEvent('vl:favorites:changed', { detail: { handle: handle, favorites: list } }));
    });
  }

  // ---------------- Linked colors ("Diğer Renkleri") ----------------
  // MK'da sections/vl-linked-colors.liquid bir <product-recommendations> section
  // endpoint'i. Modalda display:none başladığı için component'in kendi
  // IntersectionObserver lazy-load'u tetiklenmez → burada doğrudan fetch edip
  // enjekte ediyoruz (öneri yoksa bloğu kaldırıyoruz).
  function loadLinkedColors(product) {
    var wrap = contentEl.querySelector('[data-vl-qv-colors]');
    if (!wrap) return;
    var slot = wrap.querySelector('[data-vl-qv-colors-slot]');
    if (!slot) { wrap.remove(); return; }

    function inject(html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var hasItems = tmp.querySelector('.vl-linked-colors__item');
      var section = tmp.querySelector('.vl-linked-colors') || tmp.querySelector('product-recommendations');
      if (section && hasItems) {
        // Section'ın kendi başlığını gizleyip bizim başlığımızı gösteriyoruz.
        var innerHeading = section.querySelector('.vl-linked-colors__heading');
        if (innerHeading) innerHeading.remove();
        slot.innerHTML = section.innerHTML || section.outerHTML;
        wrap.classList.add('is-loaded');
      } else {
        wrap.remove();
      }
    }

    if (linkedCache[product.id]) { inject(linkedCache[product.id]); return; }

    // Shopify product recommendations endpoint (complementary intent = "Diğer Renkleri").
    // NOTE: locale-prefixed mağazalarda /recommendations/products yerine
    // routes.product_recommendations_url gerekebilir (şu an window.routes'ta yok).
    var url = '/recommendations/products?section_id=' + LINKED_SECTION_ID +
      '&intent=complementary&limit=8&product_id=' + product.id;

    fetch(url, { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.text() : Promise.reject(res.status); })
      .then(function (text) {
        linkedCache[product.id] = text;
        inject(text);
      })
      .catch(function () { wrap.remove(); });
  }

  // ---------------- Render ----------------
  function render(product) {
    var optionsHtml = buildOptions(product);

    var shipHtml = freeShip
      ? '<div class="vl-qv__ship">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true">' +
            '<path d="M1 3h13v11H1z"/><path d="M14 7h4l3 3v4h-7z"/>' +
            '<circle cx="6" cy="18" r="1.8"/><circle cx="17.5" cy="18" r="1.8"/>' +
          '</svg>' +
          '<span>' + escapeHtml(freeShip.message) + '</span>' +
        '</div>'
      : '';

    var trustHtml =
      '<ul class="vl-qv__trust" role="list">' +
        '<li class="vl-qv__trust-item">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 2 4 5v6c0 5 3.4 8.5 8 11 4.6-2.5 8-6 8-11V5l-8-3z"/><polyline points="9 12 11 14 15 10"/></svg>' +
          '<span>Güvenli ödeme</span>' +
        '</li>' +
        '<li class="vl-qv__trust-item">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M1 4h13v11H1z"/><path d="M14 8h4l3 3v4h-7z"/><circle cx="6" cy="18" r="1.6"/><circle cx="17.5" cy="18" r="1.6"/></svg>' +
          '<span>Hızlı teslimat</span>' +
        '</li>' +
        '<li class="vl-qv__trust-item">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 21s-7-4.5-7-10a4.5 4.5 0 0 1 7-3.7A4.5 4.5 0 0 1 19 11c0 5.5-7 10-7 10z"/></svg>' +
          '<span>Özenle hazırlanır</span>' +
        '</li>' +
        '<li class="vl-qv__trust-item">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><polyline points="9 14 4 14 4 9"/><path d="M20 11a8 8 0 0 0-14.9-3.4L4 9"/><polyline points="15 10 20 10 20 5"/><path d="M4 13a8 8 0 0 0 14.9 3.4L20 15"/></svg>' +
          '<span>Kolay iade</span>' +
        '</li>' +
      '</ul>';

    var favHtml =
      '<button type="button" class="vl-qv__fav" data-vl-qv-fav data-fav-handle="' + escapeHtml(product.handle) + '" aria-pressed="false">' +
        '<svg class="vl-qv__fav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M12 21s-7.5-4.6-10-9.1C.4 8.8 1.7 5.3 5 4.6c2-.4 3.9.6 5 2.3 1.1-1.7 3-2.7 5-2.3 3.3.7 4.6 4.2 3 7.3C19.5 16.4 12 21 12 21z"/></svg>' +
        '<span class="vl-qv__fav-label">Favorilere ekle</span>' +
      '</button>';

    var qtyHtml =
      '<div class="vl-qv__qty-row">' +
        '<span class="vl-qv__opt-name">Adet</span>' +
        '<div class="vl-qv__stepper">' +
          '<button type="button" class="vl-qv__step" data-vl-qv-qty-minus aria-label="Azalt">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
          '</button>' +
          '<input class="vl-qv__qty-input" type="number" inputmode="numeric" name="quantity" value="1" min="1" data-vl-qv-qty aria-label="Adet">' +
          '<button type="button" class="vl-qv__step" data-vl-qv-qty-plus aria-label="Artır">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
          '</button>' +
        '</div>' +
      '</div>';

    var html =
      '<div class="vl-qv__layout">' +
        '<div class="vl-qv__grid">' +
          buildGallery(product) +
          '<div class="vl-qv__details">' +
            (product.vendor
              ? '<span class="vl-qv__vendor">' + escapeHtml(product.vendor) + '</span>'
              : '') +
            '<h2 class="vl-qv__title">' + escapeHtml(product.title) + '</h2>' +
            '<div class="vl-qv__price" data-vl-qv-price></div>' +
            (cp
              ? '<div class="vl-cart-preview vl-cart-preview--pdp vl-qv__preview" data-vl-qv-preview hidden style="--vl-cp-color: ' + escapeHtml(cp.color) + ';"></div>'
              : '') +
            shipHtml +
            '<p class="vl-qv__stock" data-vl-qv-stock hidden></p>' +
            optionsHtml +
            '<form class="vl-qv__form" data-vl-add-form data-product-id="' + product.id + '">' +
              '<input type="hidden" name="id" value="" data-vl-qv-id>' +
              qtyHtml +
              '<button type="submit" class="vl-card__add-btn vl-qv__add-btn">' +
                '<span class="vl-card__add-label" data-vl-add-label>Sepete ekle</span>' +
                '<span class="vl-card__add-spinner" data-vl-add-spinner aria-hidden="true"></span>' +
              '</button>' +
              favHtml +
            '</form>' +
            trustHtml +
            '<a class="vl-qv__full-link" href="' + escapeHtml(product.url) + '">Ürün detayına git →</a>' +
          '</div>' +
        '</div>' +
        '<div class="vl-qv__colors" data-vl-qv-colors>' +
          '<h3 class="vl-qv__colors-heading">Diğer Renkleri</h3>' +
          '<div class="vl-linked-colors-wrap" data-vl-qv-colors-slot></div>' +
        '</div>' +
      '</div>';

    contentEl.innerHTML = html;
    contentEl.hidden = false;
    if (loadingEl) loadingEl.hidden = true;

    // Adet stepper input'u name="quantity" ile form içinde; FormData doğrudan okur.
    contentEl.querySelectorAll('[data-vl-qv-opt-btn]').forEach(function (b) {
      b.addEventListener('click', function () {
        var idx = b.getAttribute('data-option-index');
        contentEl.querySelectorAll('[data-vl-qv-opt-btn][data-option-index="' + idx + '"]').forEach(function (sib) {
          sib.classList.toggle('is-selected', sib === b);
        });
        updateVariantState(product);
      });
    });

    wireGallery();
    wireStepper();
    wireFav();
    updateVariantState(product);
    loadLinkedColors(product);
  }

  function loadProduct(handle) {
    openModal();
    // Cache hit → fetch yapma, doğrudan render et.
    if (productCache[handle]) {
      render(productCache[handle]);
      return;
    }
    showLoading();
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('quick-view fetch failed');
        return res.json();
      })
      .then(function (product) {
        productCache[handle] = product;
        render(product);
      })
      .catch(function (err) {
        console.error(err);
        if (contentEl) {
          contentEl.hidden = false;
          contentEl.innerHTML = '<p class="vl-qv__error">Ürün yüklenemedi. Lütfen ürün sayfasını açın.</p>';
        }
        if (loadingEl) loadingEl.hidden = true;
      });
  }

  // Kart üzerindeki tetikleyici (delegated)
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-vl-quick-view]');
    if (trigger) {
      event.preventDefault();
      var handle = trigger.getAttribute('data-product-handle');
      if (handle) loadProduct(handle);
      return;
    }
    if (event.target.closest('[data-vl-qv-close]')) {
      closeModal();
    }
  });

  // Sepete eklenince (vl-product-card.js publish ediyor) modali kapat → drawer açılır.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (payload) {
      if (payload && payload.source === 'vl-product-card' && modal.getAttribute('aria-hidden') === 'false') {
        closeModal();
      }
    });
  }
})();
